module.exports = __webpack_public_path__ + "img/layout-1d.071e85e5.jpg";